import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledBox = styled(Box)(({ theme }) => ({
  position: "relative"
}))

function PaperCard(props) {
  const { children } = props

  return (
    <StyledBox bgcolor="background.paper" border={1} borderColor="grey.400" borderRadius="2px" {...props}>
      <Box spacing={3} px={2} py={2}>
        {children}
      </Box>
    </StyledBox>
  )
}

export default PaperCard
